import { RegionValue } from "../contexts/RegionSelectedContext";
import EuropeRecord from "../models/EuropeRecord";
import HerfindahlRecord from "../models/HerfindahlRecord";
import LatamConcentrationRecord from "../models/LatamConcentrationRecord";
import LatamRecord from "../models/LatamRecord";

type StaticData = {
    reaseguro?: {
        records?: LatamRecord[]
        concentrationRecords?: LatamConcentrationRecord[]
        herfindahlRecords?: HerfindahlRecord[]
    }
    eu?: {
        records?: EuropeRecord[]
    }
    latam?: {
        records?: LatamRecord[]
        concentrationRecords?: LatamConcentrationRecord[]
        herfindahlRecords?: HerfindahlRecord[]
    }
}

type Dataset = keyof StaticData['reaseguro'] | keyof StaticData['eu'] | keyof StaticData['latam'];

const STATIC_URLS_TO_FETCH = [
        { region: 'eu', dataset: 'records' },
        { region: 'latam', dataset: 'records' },
        { region: 'latam', dataset: 'herfindahlRecords' },
        { region: 'latam', dataset: 'concentrationRecords' },
        { region: 'reaseguro', dataset: 'records' },
        { region: 'reaseguro', dataset: 'herfindahlRecords' },
        { region: 'reaseguro', dataset: 'concentrationRecords' }
    ] as { region: RegionValue, dataset: Dataset }[];

const DataService = (() => {
    const STATIC_DATA_URL = `${process.env.REACT_APP_BASE_URL || '/rankings'}/data`;

    const fetchUrlData = (url: string) => ( fetch(url).then((res) => res.json()) );

    const fetchStaticData = async () => {
        const staticData = await Promise.all(STATIC_URLS_TO_FETCH.map(async ({ region, dataset }) => {
            return { key: { region, dataset }, data: await fetchUrlData(STATIC_DATA_URL + '/' + region + '/' + dataset + '.json') }
        }));

        return staticData.reduce((acc, { key, data }) => {
            return { ...acc, [key.region]: { ...acc[key.region], [key.dataset]: data } };
        }, {} as StaticData);
    };


    const fetchInitialData = async () => {
        return fetchStaticData().then((apiData) => {
            // TODO: Remove @ts-ignore and handle failure of these requests (probably retry?)
            return {
              // @ts-ignore
              europeRecords: apiData.eu.records,
              // @ts-ignore
              latamRecords: apiData.latam.records,
              // @ts-ignore
              latamHerfindahlRecords: apiData.latam.herfindahlRecords,
              // @ts-ignore
              latamConcentrationRecords: apiData.latam.concentrationRecords,
              reaseguro: apiData.reaseguro
            };
        })
    };


    return {
        fetchInitialData: () => fetchInitialData()
    }
})();

export default DataService;
